import InformationImageList from './InformationImageList';

export default InformationImageList;
